import React from "react";
import { GatewayWithSourceViewStateTypes } from "@common/types/gateways-list-types";
import {
  useEditGatewayNameHook,
  UseEditGatewayNameHookProps,
} from "./use-edit-gateway-name-hook";
import styles from "./edit-gateway-name.module.scss";
import { useI18N } from "@src/language/language-context";
import { RenderIfUserHasPermission } from "../render-if-user-has-permission/render-if-user-has-permission";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import renameIcon from "@src/assets/svg/rename-blue-icon.svg";
import saveIcon from "@src/assets/svg/save-right-blue-icon.svg";
import closeIcon from "@src/assets/svg/close-orange-icon.svg";

interface EditGatewayNamePropTypes {
  gateway: GatewayWithSourceViewStateTypes;
}

const cssClassName = "edit-gateway-name";

export const EditGatewayName = ({ gateway }: EditGatewayNamePropTypes) => {
  const i18n = useI18N();
  const {
    showInput,
    editGatewayName,
    onKeyDownFunc,
    updateNewGatewayName,
    saveGatewayName,
    cancelSaveGatewayName,
    newGatewayName,
  } = useEditGatewayNameHook(gateway);

  const texts = {
    save: i18n("modules.editGatewayName.save"),
    edit: i18n("modules.editGatewayName.edit"),
    cancel: i18n("modules.editGatewayName.cancel"),
  };

  return (
    <>
      <span className={styles[cssClassName]}>
        {!showInput && (
          <span className={styles[`${cssClassName}__item-name-wrapper`]}>
            <span className={styles[`${cssClassName}__item-name`]}>
              {newGatewayName || gateway.name}
            </span>

            <RenderIfUserHasPermission permission="manage-gateways">
              <span className={styles[`${cssClassName}__edit-text-button`]}>
                <IconButton
                  fun={(e) => editGatewayName(e)}
                  icon={renameIcon}
                  tooltip={texts.edit}
                  variant="edit-save-close-icon"
                />
              </span>
            </RenderIfUserHasPermission>
          </span>
        )}
        {showInput && (
          <>
            <span
              className={styles[`${cssClassName}__item-name-input-wrapper`]}
            >
              <input
                type="text"
                value={newGatewayName}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onChange={(e) => {
                  updateNewGatewayName(e, e.target.value);
                }}
                onKeyDown={(e) => {
                  onKeyDownFunc(e);
                }}
                className={styles[`${cssClassName}__item-name-input`]}
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus
              />
            </span>
            <div className={styles[`${cssClassName}__buttons-wrapper`]}>
              <span className={styles[`${cssClassName}__save-text-button`]}>
                <IconButton
                  fun={(e) => saveGatewayName(e)}
                  icon={saveIcon}
                  tooltip={texts.save}
                  variant="edit-save-close-icon"
                />
              </span>
              <span className={styles[`${cssClassName}__cancel-text-button`]}>
                <IconButton
                  fun={(e) => cancelSaveGatewayName(e)}
                  icon={closeIcon}
                  tooltip={texts.cancel}
                  variant="edit-save-close-icon"
                />
              </span>
            </div>
          </>
        )}
      </span>
    </>
  );
};
